var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-6"},[_c('h5',{staticClass:"card-title"},[(_vm.form && _vm.form.uuid)?[_vm._v(" Edit ")]:[_vm._v(" Add ")],_vm._v(" "+_vm._s(_vm.title)+" ")],2)]),_c('div',{staticClass:"col-sm-12 col-md-6 text-end"},[_c('loader',{attrs:{"is-loading":_vm.processing}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }